import { render } from "./ControlAccesoSuscripciones.vue?vue&type=template&id=5ce23644&scoped=true"
import script from "./ControlAccesoSuscripciones.vue?vue&type=script&lang=js"
export * from "./ControlAccesoSuscripciones.vue?vue&type=script&lang=js"

import "./ControlAccesoSuscripciones.vue?vue&type=style&index=0&id=5ce23644&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce23644"]])

export default __exports__